export default __webpack_public_path__ + "static/media/bg-contacto.fef7bb27.jpeg";